import type { BuilderConfig } from '@/types/builder';
import SearchGlobalHero from './SearchGlobalHero.vue';

export default {
    component: SearchGlobalHero,
} satisfies BuilderConfig;
